// src/utils/authUtils.js
import config from '../config';
import notificationService from '../services/notificationService';

export const authUtils = {
  // Check if user is currently authenticated
  isAuthenticated: () => {
    return !!(config.token && config.user);
  },

  // Initialize notifications for already authenticated user (on app startup)
  initializeForAuthenticatedUser: async () => {
    try {
      if (!authUtils.isAuthenticated()) {
        console.log('User not authenticated, skipping notification initialization');
        return false;
      }

      console.log('User already authenticated, initializing notifications...');
      
      // Use the login-specific initialization method which includes auth checks
      const success = await notificationService.initializeAfterLogin();
      
      if (success) {
        console.log('Notifications initialized for authenticated user on app startup');
      } else {
        console.log('Failed to initialize notifications for authenticated user');
      }
      
      return success;
    } catch (error) {
      console.error('Error initializing notifications for authenticated user:', error);
      return false;
    }
  },

  // Get user info
  getUserInfo: () => {
    return config.user;
  },

  // Get auth token
  getAuthToken: () => {
    return config.token;
  }
};

export default authUtils;
